export enum ConsultantQueryBookingStatus {
  /**
   * Consultant has never been booked
   */
  NoBookings = "NoBookings",

  /**
   * Consultant has no non-canceled bookings from a date onwards
   * this is unclear, seems to be the same as NoBookingsFromDateBookedPreviously
   */
  NoBookingsFromDate = "NoBookingsFromDate",

  /**
   * Consultant has no non-canceled bookings from a date onwards
   * but has been booked previously (non-canceled bookings)
   */
  NoBookingsFromDateBookedPreviously = "NoBookingsFromDateBookedPreviously",

  /**
   * Consultant has no bookings within a certain period
   */
  NoBookingsInPeriod = "NoBookingsInPeriod",

  /**
   * Consultant has non-canceled bookings from a date onwards
   */
  HasBookingsFromDate = "HasBookingsFromDate",

  /**
   * Consultant has bookings within a certain period but not have after that period.
   */
  BookingsInPeriodButNotAfter = "BookingsInPeriodButNotAfter",

  /**
   * No booking weeks before selected date
   */
  NoBookingsBeforeDate = "NoBookingsBeforeDate",

  /**
   * Consultant has bookings within a certain period
   */
  BookingsInPeriod = "BookingsInPeriod"
}
